import axios, { AxiosResponse } from 'axios';
import { con } from '../../../application/entity/Rutas';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

export class SVCParametros {

    public static async ObtieneParametros(codigoParametro: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Parametro/getParametro";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    'codigoParametro': codigoParametro
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    
    public static async ObtieneParametrosPago(rut: string,codCarrera: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionMandatoPac/datosAlumno";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    'rut': rut,
                    'codCarrera': codCarrera
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
	

    public static async ObtieneDias(codigoParametro: string, mes: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Parametro/getParametroPostDEC";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    'codigoParametro': codigoParametro,
                    'mes': mes === '' ? 0 : mes
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneProcesoActual(data: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Parame/getParame";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtienePanelesTipoPersonaValidar(codigoNegocio: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TipoPersona/getTipoPersonaParaValidacion";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    'codigoNegocio': codigoNegocio
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneBancosActual(data: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Banco/getBanco";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneCuentasActual(): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "TipoCuenta/getTipoCuenta";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerMonedas(data: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Moneda/getListaMoneda";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .post(url, {
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtenerPariedad(data: number, fecha:string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Paridad/getParidad";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        var f = new Date(fecha)
        var d = f.getFullYear() + '-' + ((f.getMonth() + 1).toString().length === 1 ? ('0' + (f.getMonth() + 1)) : (f.getMonth() + 1)) + '-' + (f.getDate().toString().length === 1 ? ('0' + f.getDate()) : f.getDate())
        await axios
            .post(url, {
                "codigoMoneda": data,
                "fecha": d
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneMensajeBloqueoAcceso(): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Mensaje/GetMensajeBloqueoAcceso";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneParametrosBool(codigoParametro: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "Parametro/getParametroBool";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";

        await axios
            .get(url, {
                params: {
                    'codigoParametro': codigoParametro
                }
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
}